import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { TUserRole } from '../../types/currentUser';

const initialState = null as TUserRole;

export const userRoleSlice = createSlice({
  name: 'userRole',
  initialState,
  reducers: {
    setUserRole: (state, action: PayloadAction<TUserRole>) => {
      return action.payload;
    },
  },
});

export const {
  reducer: userRoleReducer,
  actions: { setUserRole },
} = userRoleSlice;
